import { axiosInstance as request } from '@/api/rest.service'

export const getRows = params => request.get('/global-search?paginated=true', { params })
